import { render } from "./SistemiProkurorial.vue?vue&type=template&id=1e365ef4&scoped=true"
import script from "./SistemiProkurorial.vue?vue&type=script&lang=js"
export * from "./SistemiProkurorial.vue?vue&type=script&lang=js"

import "./SistemiProkurorial.vue?vue&type=style&index=0&id=1e365ef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e365ef4"]])

export default __exports__